export const emojiPageId = {
  redHeart: 'red-heart',
  star: 'star',
  christmasTree: 'christmas-tree',
  meltingFace: 'melting-face',
  eyes: 'eyes',
  huggingFace: 'hugging-face',
  thumbsUp: 'thumbs-up',
  flushedFace: 'flushed-face',
  fire: 'fire',
  zzz: 'zzz',
};

export const categoryPageId = {
  activities: 'activities',
  flags: 'flags',
  foodDrink: 'food-drink',
  nature: 'nature',
  objects: 'objects',
  people: 'people',
  symbols: 'symbols',
  travelPlaces: 'travel-places',
};

export enum PAGE_TYPE {
  emoji,
  category,
}
